/* ==============================================================================
   25ans 下層ページ — sections/lp-25ans-sub.liquid から読み込む
   ==============================================================================
   現行サイト（https://pierremarcolini.jp/25ans/）の common-25ans.js / product.js は
   jQuery と Magnific Popup 前提だったので、テーマに jQuery を足さずに済むよう
   同じ挙動を素の JS で書き直したもの。

   ・スクロール連動アニメーション（.js-scroll-advanced に isActive を付ける）
   ・.popup-modal → href の要素をポップアップ表示（Magnific Popup の DOM 構造を再現し、
     移植した magnific-popup.css がそのまま効くようにしている）
   ・[data-modal-target] / [data-modal-close] の動画モーダル
   ・.splide のスライダー（assets/splide.min.js）
   ・target="_blank" の YouTube リンクはテーマの動画モーダルに取られず別タブで開く
   ------------------------------------------------------------------------------ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---------- スクロール連動アニメーション ---------- */
  function initScrollAnimation() {
    var targets = document.querySelectorAll('#pm25ans .js-scroll-advanced');
    if (!targets.length) return;
    var vh = window.innerHeight;
    var obs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries, o) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('isActive'); o.unobserve(e.target); }
      });
    }, { root: null, rootMargin: '-90% 0px -5%', threshold: 0 }) : null;

    Array.prototype.forEach.call(targets, function (el) {
      var r = el.getBoundingClientRect();
      // すでに通過している・画面内にいる要素は即表示
      if (r.bottom < 0 || (r.top < vh && r.bottom > 0) || !obs) { el.classList.add('isActive'); return; }
      obs.observe(el);
    });
    // 保険: 3 秒後も非表示のままの要素は強制表示（JS が失敗しても本文が消えないように）
    setTimeout(function () {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('isActive'); });
    }, 3000);
  }


  /* ---------- .popup-modal（Magnific Popup の inline 型を再現） ---------- */
  function initPopupModal() {
    var triggers = document.querySelectorAll('#pm25ans .popup-modal');
    if (!triggers.length) return;

    var current = null; // { box, placeholder, bg, wrap }

    function closePopup() {
      if (!current) return;
      var c = current;
      current = null;
      c.bg.classList.remove('mfp-ready');
      c.wrap.classList.remove('mfp-ready');
      c.bg.classList.add('mfp-removing');
      c.wrap.classList.add('mfp-removing');
      setTimeout(function () {
        // 中身を元の場所に戻して隠す
        c.box.classList.add('mfp-hide');
        c.placeholder.parentNode.replaceChild(c.box, c.placeholder);
        var btn = c.box.querySelector('.mfp-close');
        if (btn) btn.parentNode.removeChild(btn);
        c.bg.parentNode.removeChild(c.bg);
        c.wrap.parentNode.removeChild(c.wrap);
        document.body.classList.remove('scroll-lock');
      }, 200); // removalDelay: 200 に合わせる
    }

    function openPopup(box) {
      if (current) return;
      var placeholder = document.createComment('mfp-placeholder');
      box.parentNode.insertBefore(placeholder, box);

      var bg = document.createElement('div');
      bg.className = 'mfp-bg mfp-inline-holder';
      var wrap = document.createElement('div');
      wrap.className = 'mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-inline-holder';
      wrap.setAttribute('tabindex', '-1');
      wrap.style.overflow = 'hidden auto';
      var container = document.createElement('div');
      container.className = 'mfp-container mfp-s-ready mfp-inline-holder';
      var content = document.createElement('div');
      content.className = 'mfp-content';

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'mfp-close';
      closeBtn.title = 'close';
      closeBtn.innerHTML = '<span></span><span></span>';

      box.classList.remove('mfp-hide');
      box.appendChild(closeBtn);
      content.appendChild(box);
      container.appendChild(content);
      wrap.appendChild(container);
      document.body.appendChild(bg);
      document.body.appendChild(wrap);
      document.body.classList.add('scroll-lock');

      current = { box: box, placeholder: placeholder, bg: bg, wrap: wrap };

      // 次のフレームで mfp-ready を付けてフェードイン
      requestAnimationFrame(function () {
        bg.classList.add('mfp-ready');
        wrap.classList.add('mfp-ready');
      });

      closeBtn.addEventListener('click', closePopup);
      wrap.addEventListener('click', function (e) {
        // 中身の外側（暗い部分）をクリックしたら閉じる
        if (!content.contains(e.target)) closePopup();
      });
    }

    Array.prototype.forEach.call(triggers, function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var box = document.getElementById(href.slice(1));
        if (!box) return;
        e.preventDefault();
        openPopup(box);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });
  }

  /* ---------- [data-modal-target] の動画モーダル ---------- */
  function initVideoModal() {
    var triggers = document.querySelectorAll('#pm25ans [data-modal-target]');
    if (!triggers.length) return;

    function closeModal(modal) {
      modal.classList.remove('is-visible');
      var video = modal.querySelector('video');
      if (video) { video.pause(); video.currentTime = 0; }
      var iframe = modal.querySelector('iframe');
      if (iframe) { iframe.src = iframe.src; } // 再読み込みして再生を止める
    }

    Array.prototype.forEach.call(triggers, function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var modal = document.getElementById(t.getAttribute('data-modal-target'));
        if (modal) modal.classList.add('is-visible');
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('#pm25ans [data-modal-close]'), function (btn) {
      btn.addEventListener('click', function () {
        var modal = btn.closest('.modal');
        if (modal) closeModal(modal);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      Array.prototype.forEach.call(document.querySelectorAll('#pm25ans .modal.is-visible'), closeModal);
    });
  }

  /* ---------- target="_blank" の YouTube リンクを別タブで開く ----------
     theme.js の videoModal は YouTube へのリンクすべてにクリックを仕込み、
     ページ内の動画モーダルで再生する。産地ポップアップ（Magnific Popup の再現、
     z-index 1043）の中ではそのモーダルが後ろに隠れ、音声だけ流れる状態になるので、
     別タブ指定のリンクは capture 段階で伝播を止め、通常のリンクとして開かせる。
     ポップアップ中の要素は body 直下の .mfp-content に移動しているため、
     #pm25ans ではなく .lp-25ans-sub / .mfp-content のどちらかの中にあるかで判定する。 */
  function initExternalYouTubeLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[target="_blank"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!/youtu\.be\/|youtube\.com\/watch/.test(href)) return;
      if (!a.closest('.lp-25ans-sub') && !a.closest('.mfp-content')) return;
      e.stopPropagation();
    }, true);
  }

  /* ---------- Splide スライダー ---------- */
  function initSplide() {
    var sliders = document.querySelectorAll('#pm25ans .splide');
    if (!sliders.length || !window.Splide) return;
    Array.prototype.forEach.call(sliders, function (el) {
      if (el.lpSplide) return;
      el.lpSplide = new window.Splide(el, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        rewind: true,
        autoplay: true,
        focus: 0,
        drag: true,
        arrows: false,
        pagination: true,
        padding: '5%',
        gap: '20px',
        pauseOnHover: false,
        breakpoints: {
          768: {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            rewind: true,
            autoplay: true,
            drag: true,
            arrows: false,
            pagination: true,
            interval: 6000,
            speed: 1500,
            padding: '20%',
            gap: '20px',
            pauseOnHover: false
          }
        }
      }).mount();
    });
  }

  ready(function () {
    initScrollAnimation();
    initPopupModal();
    initVideoModal();
    initExternalYouTubeLinks();
    initSplide();
  });
  // 現行サイトは load 後に body へ loaded-25ans を付けていた（CSS のフェードイン用）
  window.addEventListener('load', function () { document.body.classList.add('loaded-25ans'); });
})();
